// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ma-0","value":"styles_value__39GsW","copy":"styles_copy__1z0Ll"};